// Base
import Image from 'next/image'

// Components
import { Box, Flex, Text } from 'yard-utilities/components'
import Section from '@components/v25/section/Section'
import MainButton from '@components/v25/ft1/buttons/MainButton'

// Assets
import HeroImage from '@images/v25/ft1/photos/travel-experience.png'

// Styles
import styles from './TravelExperience.module.sass'

// Data
import data from '@data/v25/ft1/travel-experience.json'

interface TravelExperienceProps {
  redirectURL?: string
  onClick?: () => void
}

const TravelExperience = ({ redirectURL, onClick }: TravelExperienceProps) => {
  return (
    <Section padding={[32, 0, 64]}>
      <Text
        tagName="h2"
        variant="title-2"
        align="center"
        transform="capitalize"
        spacing={{ sm: 32 }}
      >
        Get ready to elevate your travel experience
      </Text>

      <Image
        src={HeroImage}
        alt="Young couple eating lunch by the pool"
        width={500}
        height={500}
        priority
        className={styles.image}
      />

      <Box spacing={{ sm: 32 }}>
        <Flex flexDirection="column" rowGap={{ sm: 16 }}>
          {data.map((item) => (
            <ListItem {...item} key={item.alt} />
          ))}
        </Flex>
      </Box>

      <MainButton redirectURL={redirectURL} onClick={onClick} />
    </Section>
  )
}

interface ListItemProps {
  src: string
  alt: string
  title: string
  body: string
}

const ListItem = ({ src, alt, title, body }: ListItemProps) => {
  return (
    <Flex columnGap={{ sm: 16 }} alignItems="flex-start">
      <ListItemIcon src={src} alt={alt} />

      <Flex flexDirection="column">
        <Text
          tagName="h4"
          variant="title-3"
          transform="capitalize"
          fontWeight={600}
          spacing={{ sm: 4 }}
        >
          {title}
        </Text>
        <Text tagName="p" variant="body-3" textColor="grey-2">
          {body}
        </Text>
      </Flex>
    </Flex>
  )
}

const ListItemIcon = ({ src, alt }: { src: string; alt: string }) => {
  return (
    <Box
      borderRadius={{ sm: [8] }}
      padding={{ sm: [6, 8] }}
      backgroundColor="blue"
      opacity={30}
    >
      <Image src={src} alt={alt + ' icon'} width={24} height={24} />
    </Box>
  )
}

export default TravelExperience
